import React, {Component} from 'react';
import {connect} from 'react-redux';
import Truncate from 'react-truncate';
import numeral from 'numeral';
import classnames from 'classnames';
import ProductImage from '../common/product/product-image';
import ProductData from '../common/product/product-data';
import ArrowButton from '../common/button-arrow';

import './styles.css';
import './card.css';
import t from '../../data/translations';

class Card extends Component {
  availableFlags = () => {
    const { product } = this.props;
    const flags = [];
    if (product.attributes['special-featured']) {
      flags.push({text: 'Featured', style: 'special-featured'});
    }
    if (product.attributes['special-new']) {
      flags.push({text: 'New', style: 'special-new'});
    }
    if (product.attributes['special-sell-it']) {
      flags.push({text: 'Sell IT', style: 'special-sell-it'});
    }
    if (product.attributes['special-stock-it']) {
      flags.push({text: 'Stock IT', style: 'special-stock-it'});
    }
    if (product.attributes['special-price-it']) {
      flags.push({text: 'Price IT', style: 'special-price-it'});
    }

    return flags;
  };

  renderFlags = () =>
    this.availableFlags()
      .map(flag => (
        <div
          key={flag.style}
          className={`product-flag product-flag-${this.availableFlags().length}`}
        >
          <div className={flag.style}>
            {flag.text}
          </div>
        </div>
      ));

  handleMoreInfoClick = () => {
    window.open(this.getMoreInfoLink(), '_blank');
  };

  getMoreInfoLink = () => {
    const {product} = this.props;
    if (product.attributes.hyperlink.match(/^https?:.*/i)) {
      return product.attributes.hyperlink;
    }
    return `${window.location.protocol}//${window.location.host}/${product.attributes.hyperlink.replace(/^\//, '')}`;
  };

  render() {
    const {product, expandTitle} = this.props;
    const image = product.attributes.links ? product.attributes.links.image : product.attributes.image;
    const rrp = product.attributes.price ? product.attributes.price : product.attributes.rsp;
    const productDataLabel = product.attributes.price ? 'PRICE' : t('rsp');

    return (
      <div>
        <div className="product-flags">
          {this.renderFlags()}
        </div>
        <div
          className={classnames({
            'product-card': true,
            featured: product.attributes['special-featured'],
          })}
        >
          <ProductImage
            div
            image={image}
          />
          <div className='product-details-container'>
            <h4
              className={classnames({expanded: expandTitle})}
              onClick={this.toggleLines}
            >

              <Truncate
                ellipsis={(
                  <span className="open-title">
...
                    <span className="container">
                      <i
                        className="fa fa-angle-down"
                      />
                    </span>
                  </span>
                )}
                lines={!expandTitle && 2}
              >
                {product.attributes.name}
              </Truncate>
              {expandTitle && (
                <div className="collapse-title">
                  <div className="container">
                    <i className="fa fa-angle-up"/>
                  </div>
                </div>
              )}

            </h4>

            <ProductData
              data={[{
                label: productDataLabel,
                value: (rrp ? `${t('currency')}${numeral(rrp).format('0.00')}` : ''),
                showToolTip: product.attributes['special-price-it']
              }]}
            />
            {product.attributes.hyperlink && (
              <ArrowButton
                submit={false}
                onClick={this.handleMoreInfoClick}
              >
                More info
              </ArrowButton>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filter: state.productPage.filter,
});

export default connect(mapStateToProps)(Card);



// WEBPACK FOOTER //
// ./src/components/product-page/card.jsx